import { ErrorBoundary } from "react-error-boundary";
import {
  RequiredAgreements,
  RequiredAgreementsProps,
} from "@grow-therapy-team/seedling-components";
import { twMerge } from "tailwind-merge";

export interface RequiredAgreementsWrapperProps
  extends RequiredAgreementsProps {
  className?: string;
}
/** @deprecated old component */
export function RequiredAgreementsWrapper({
  className,
  ...props
}: RequiredAgreementsWrapperProps) {
  return (
    <ErrorBoundary FallbackComponent={() => null}>
      <div
        className={twMerge(
          "rounded-lg border border-neutral-800 p-8",
          className,
        )}
      >
        <RequiredAgreements {...props} />
      </div>
    </ErrorBoundary>
  );
}
